<template>
  <div class="validate pa-4">
    <v-card max-width="600"
            class="mx-auto">
      <v-card-title>Validate authorization token</v-card-title>
      <v-card-text>
        <v-form v-model="valid">
          <v-container>
            <v-row>
              <v-select v-model="environment"
                        :items="environments"
                        label="Environment"
                        outlined>
              </v-select>
            </v-row>
            <v-row>
              <v-text-field v-model="tenantUuid"
                            :rules="tenantUuidRules"
                            :counter="36"
                            label="Tenant UUID"
                            outlined
                            required>
              </v-text-field>
            </v-row>
            <v-row>
              <v-textarea v-model="token"
                          label="Token"
                          :rules="tokenRules"
                          no-resize
                          outlined
                          required>
              </v-textarea>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
      <v-alert :type="messageType"
               :value="isMessageVisible"
               class="ma-2 mt-0">
        {{message}}
      </v-alert>
      <v-card-actions>
        <v-btn :disabled="!valid"
               color="primary"
               @click="validate">
          Validate
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import api from '@/api';

const environments = [
  { text: 'Production', value: 'production' },
  { text: 'Staging', value: 'staging' },
  { text: 'Development', value: 'development' },
];

export default {
  name: 'Validate',
  data: () => ({
    environments,
    environment: environments[0].value,
    message: '',
    messageType: 'info',
    tenantUuid: '',
    tenantUuidRules: [
      v => !!v || 'Tenant UUID is required',
      v => v.length === 36 || 'Tenant UUID must be 36 characters length',
    ],
    token: '',
    tokenRules: [
      v => !!v || 'Token is required',
    ],
    valid: false,
  }),
  computed: {
    isMessageVisible() {
      return this.message.length > 0;
    },
  },
  methods: {
    validate() {
      api.validate({
        environment: this.environment,
        tenantUuid: this.tenantUuid,
        token: this.token,
      }).then((result) => {
        this.message = JSON.stringify(result.data);
        this.messageType = 'success';
      }).catch((error) => {
        this.message = error.response.data.message;
        this.messageType = 'error';
      });
    },
  },
};
</script>
